import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import ChevronLeftIcon from "../../../assets/svg/ChevronLeftIcon";
import { getApplicantList, getJobById } from "../../../endpoints/job.service";
import Spinner from "../../../components/Spinner/Spinner";
import { useDispatch } from "react-redux";
import { setJobDetail } from "../../../store/actions/job.action";
import EmailOpenIconFilled from "@assets/svg/EmailOpenIconFilled";
import SubmissionQueueModal from "./components/SubmissionQueueModal";
import CandidateSentSuccessModal from "./components/CandidateSentSuccessModal";

const tabs = [
  { name: "Job Post", path: "job-post" },
  { name: "Applicants List", path: "applicants" },
  // { name: "Shortlisted", path: "shortlisted" },
];

const JobDetail = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [loading, setLoading] = useState(true);
  const [showSubmissionQueueModal, setShowSubmissionQueueModal] =
    useState(false);
  const [showCandidateSentModal, setShowCandidateSentModal] = useState(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchJobDetails();
    }
  }, []);

  const fetchJobDetails = async () => {
    try {
      const jobResponse = await getJobById({ jobId });
      const { data: jobData, success: jobSuccess } = jobResponse;
      if (jobSuccess) {
        const applicantResponse = await getApplicantList(jobId);
        const { data: applicantData, success: applicantSuccess } =
          applicantResponse;
        if (applicantSuccess) {
          dispatch(setJobDetail({ ...jobData, applicantData }));
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow px-4 py-3">
      <div className="flex items-center gap-[32rem]">
        <button
          onClick={() => navigate("/job")}
          className="flex items-center"
        >
          <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
          <label className="text-xs font-medium text-primary cursor-pointer">
            Back to listing
          </label>
        </button>
        <button
          onClick={() => setShowSubmissionQueueModal(true)}
          className="border rounded-md h-10 w-10 flex items-center justify-center hover:bg-gray-100">
          <EmailOpenIconFilled fill="#2e2e2e" />
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Spinner />
        </div>
      ) : (
        <>
          {/* Header starts here */}
          <div className="flex items-end justify-between border-b px-3 mt-5 pb-2">
            <div className="flex items-center gap-10">
              {tabs?.map((item, index) => {
                const isActive = pathname?.includes(item?.path);
                return (
                  <button
                    onClick={() => navigate(item?.path)}
                    key={index}
                    className={`flex items-center ${isActive ? "border-b border-primary" : ""
                      }`}
                  >
                    <span
                      className={`text-xs ${isActive ? "text-primary font-medium" : "text-gray-500"
                        }`}
                    >
                      {item?.name}
                    </span>
                  </button>
                );
              })}
            </div>
            {/* <button
              onClick={() => setShowSubmissionQueueModal(true)}
              className="flex items-center gap-2 text-xs font-medium text-primary border border-primary rounded-md h-9 px-3 hover:bg-gray-100"
            >
              <EmailOpenIconFilled fill="#2e2e2e" />
              Submission Queue
            </button> */}
          </div>
          {/* Header ends here  */}
          <div className="flex flex-1 flex-col overflow-y-hidden no-scrollbar">
            <Outlet />
          </div>
          {/* SubmissionQueueModal */}
          <SubmissionQueueModal
            openModal={showSubmissionQueueModal}
            setOpenModal={setShowSubmissionQueueModal}
            jobId={jobId}
            onSubmit={() => {
              setShowCandidateSentModal(true);
            }}
          />
          {/* CandidateSentSuccessModal */}
          <CandidateSentSuccessModal
            openModal={showCandidateSentModal}
            setOpenModal={setShowCandidateSentModal}
            jobId={jobId}
          />
        </>
      )}
    </div>
  );
};

export default JobDetail;
